import { createFileRoute, useNavigate, redirect } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SpareForm } from "@/features/spares/SpareForm";
import { canCreateSpare } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/spares/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateSpare(me.roles)) throw redirect({ to: "/spares" });
  },
  component: NewSparePage,
  validateSearch: (s: Record<string, unknown>) => {
    const t = s.type;
    return { type: (t === "consumable" ? "consumable" : "spare") as "spare" | "consumable" };
  },
});

import { ConsumableForm } from "@/features/spares/ConsumableForm";

function NewSparePage() {
  const navigate = useNavigate();
  const { type } = Route.useSearch();
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/spares" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      {type === "consumable" ? (
        <ConsumableForm />
      ) : (
        <SpareForm defaultItemType={type} />
      )}
    </div>
  );
}
